import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HomeComponent } from './components/home.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HomeService } from './services/home.service';
import { DxPopoverModule, DxScrollViewModule, DxTemplateModule } from 'devextreme-angular';
import { HomeTitleComponent } from './components/home-title/home-title.component';
import { CoreModule } from '@gah-core/core.module';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgStreamingModule } from '@videogular/ngx-videogular/streaming';
import { MaterialModule } from 'src/app/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({ declarations: [HomeComponent, HomeTitleComponent], imports: [
        MaterialModule,
        CommonModule,
        CoreModule,
        HomeRoutingModule,
        NgxSpinnerModule,
        DxPopoverModule,
        DxTemplateModule,
        DxScrollViewModule,
        NgxSkeletonLoaderModule,
        TranslateModule.forChild(),
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgStreamingModule,
],
schemas:[CUSTOM_ELEMENTS_SCHEMA],
        providers: [HomeService, provideHttpClient(withInterceptorsFromDi())] })
export class HomeModule {}
